<script>
import BeritaPost from "./sections/berita-post.vue";
export default {
  components: {
    BeritaPost,
  },
  props: ["data", "addClass", "meta"],
  data() {
    return {};
  },
};
</script>
<template>
  <div
    class="section-news blog-grid-area section-space--inner--50"
    :class="addClass"
  >
    <div class="container position-relative mt-4 mb-4">
      <div class="bg-home--berita"></div>
      <div class="row text-center mb-5">
        <div class="col-lg-12">
          <h3 class="text-color-default font-size-24">
            <span class="span-hr">BERITA</span>
          </h3>
          <br />
          <h3>Baca info berita terkini dari Sekolahmu</h3>
          <!-- <p class="font-size-15">Nikmati portal berita {{ this.meta.name }} dari berbagai macam kegiatan dan info terkini </p> -->
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="blog-grid-wrapper">
            <div v-if="data.length > 0" class="row justify-content-center">
              <div
                class="col-lg-4 col-md-6"
                v-for="item in data.slice(0, 3)"
                :key="item.id"
              >
                <BeritaPost
                  :berita="item"
                  :meta="meta"
                  textColor="text-color-default"
                />
              </div>
            </div>
            <div v-else class="row justify-content-center">
              <div class="col-lg-4 col-md-6">
                <div
                  class="blog-post-slider__single-slide blog-post-slider__single-slide--grid-view"
                >
                  <div
                    class="blog-post-slider__image section-space--bottom--20"
                  >
                    <router-link :to="`#`">
                      <img
                        src="@/assets/images/global/list_empty.png"
                        class="img-fluid img-berita"
                        alt="blog-image"
                      />
                    </router-link>
                  </div>
                  <div class="blog-post-slider__content">
                    <h3 class="post-title">
                      <router-link
                        data-toggle="tooltip"
                        data-placement="top"
                        to="#"
                        >Data belum tersedia</router-link
                      >
                    </h3>
                    <p class="post-date">
                      Data belum tersedia
                    </p>
                    <p class="post-excerpt">
                      Data belum tersedia
                    </p>
                    <div class="text-right">
                      <router-link to="`#" class="font-weight-bold"
                        >Selengkapnya</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div
                  class="blog-post-slider__single-slide blog-post-slider__single-slide--grid-view"
                >
                  <div
                    class="blog-post-slider__image section-space--bottom--20"
                  >
                    <router-link :to="`#`">
                      <img
                        src="@/assets/images/global/list_empty.png"
                        class="img-fluid img-berita"
                        alt="blog-image"
                      />
                    </router-link>
                  </div>
                  <div class="blog-post-slider__content">
                    <h3 class="post-title">
                      <router-link
                        data-toggle="tooltip"
                        data-placement="top"
                        to="#"
                        >Data belum tersedia</router-link
                      >
                    </h3>
                    <p class="post-date">
                      Data belum tersedia
                    </p>
                    <p class="post-excerpt">
                      Data belum tersedia
                    </p>
                    <div class="text-right">
                      <router-link to="`#" class="font-weight-bold"
                        >Selengkapnya</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div
                  class="blog-post-slider__single-slide blog-post-slider__single-slide--grid-view"
                >
                  <div
                    class="blog-post-slider__image section-space--bottom--20"
                  >
                    <router-link :to="`#`">
                      <img
                        src="@/assets/images/global/list_empty.png"
                        class="img-fluid img-berita"
                        alt="blog-image"
                      />
                    </router-link>
                  </div>
                  <div class="blog-post-slider__content">
                    <h3 class="post-title">
                      <router-link
                        data-toggle="tooltip"
                        data-placement="top"
                        to="#"
                        >Data belum tersedia</router-link
                      >
                    </h3>
                    <p class="post-date">
                      Data belum tersedia
                    </p>
                    <p class="post-excerpt">
                      Data belum tersedia
                    </p>
                    <div class="text-right">
                      <router-link to="`#" class="font-weight-bold"
                        >Selengkapnya</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 text-center">
          <router-link
            to="/berita"
            class="btn ht-btn-default--round mt-4 btn-primary-theme"
            >BACA LAINNYA</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/6-responsive/template-blue/index.scss";
</style>
